export default __webpack_public_path__ + "static/media/golden-x-mark.64a765c2.svg";